import { render, staticRenderFns } from "./ProfileSecurityConfig.vue?vue&type=template&id=2ef01811"
import script from "./ProfileSecurityConfig.vue?vue&type=script&lang=ts"
export * from "./ProfileSecurityConfig.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports